import React from "react";

import {
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Divider,
  Flex,
  FlexItem,
  Stack,
  StackItem
} from "@patternfly/react-core";

import {
  LOGO_SIZES
} from "shared/constants/logoSizes";


const SectionPanel = ({
  logos = [],
  logosClickable = true,
  header = null,
  action = null,
  isCard = false,
  isLarge = true,
  variant = "primary",
  children
}) => {
  const hasLogos =
    Array.isArray(logos) &&
    logos.length > 0;

  const renderLogo = (logo) => {
    const height =
      logo.height ??
      LOGO_SIZES.desktop[logo.size ?? "md"];

    const image = (
      <img
        src={logo.src}
        alt={logo.alt || ""}
        loading="eager"
        style={{
          display: "block",
          width: "auto",
          height: `${height}px`,
          ...(logo.offset && {
            transform: `translate(
              ${logo.offset.x ?? 0}px,
              ${logo.offset.y ?? 0}px
            )`
          })
        }}
      />
    );

    if (!logosClickable || !logo.href) {
      return image;
    }

    return (
      <a
        href={logo.href}
        target={
          logo.external
            ? "_blank"
            : undefined
        }
        rel={
          logo.external
            ? "noopener noreferrer"
            : undefined
        }
        aria-label={logo.alt || undefined}
      >
        {image}
      </a>
    );
  };

  const logosContent = hasLogos ? (
    <Flex
      justifyContent={{
        default: "justifyContentCenter"
      }}
      alignItems={{
        default: "alignItemsCenter"
      }}
      spaceItems={{
        default: "spaceItemsMd"
      }}
    >
      {logos.map((logo) => (
        <FlexItem key={logo.id}>
          {renderLogo(logo)}
        </FlexItem>
      ))}
    </Flex>
  ) : null;

  if (isCard) {
    return (
      <Card
        variant={variant}
        isLarge={isLarge}
      >
        {(hasLogos || header) && (
          <CardTitle>
            <Stack hasGutter>
              {hasLogos && (
                <>
                  <StackItem>
                    {logosContent}
                  </StackItem>

                  <StackItem>
                    <Divider />
                  </StackItem>
                </>
              )}

              {header && (
                <StackItem>
                  {header}
                </StackItem>
              )}
            </Stack>
          </CardTitle>
        )}

        <CardBody>
          {children}
        </CardBody>

        {action && (
          <CardFooter>
            <Flex
              justifyContent={{
                default: "justifyContentCenter"
              }}
            >
              <FlexItem>
                {action}
              </FlexItem>
            </Flex>
          </CardFooter>
        )}
      </Card>
    );
  }

  return (
    <Stack hasGutter>
      {hasLogos && (
        <>
          <StackItem>
            {logosContent}
          </StackItem>

          <StackItem>
            <Divider />
          </StackItem>
        </>
      )}

      {header && (
        <StackItem>
          {header}
        </StackItem>
      )}

      <StackItem>
        {children}
      </StackItem>

      {action && (
        <StackItem>
          <Flex
            justifyContent={{
              default: "justifyContentCenter"
            }}
          >
            <FlexItem>
              {action}
            </FlexItem>
          </Flex>
        </StackItem>
      )}
    </Stack>
  );
};


export default SectionPanel;